import { useCallback, useEffect, useRef, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useChatwootToken() {
  const [hasToken, setHasToken] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const isMountedRef = useRef(true);

  const refresh = useCallback(async () => {
    if (!isMountedRef.current) return;
    try {
      setLoading(true);

      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) {
        if (isMountedRef.current) {
          setHasToken(false);
          setLoading(false);
        }
        return;
      }

      const { data, error } = await supabase
        .from("profiles")
        .select("chatwoot_user_token, chatwoot_user_id")
        .eq("id", user.id)
        .maybeSingle();

      if (error) {
        console.warn("useChatwootToken: erro ao buscar profile", error);
        if (isMountedRef.current) {
          setHasToken(false);
          setLoading(false);
        }
        return;
      }

      const tokenPresent = Boolean(data?.chatwoot_user_token);
      const userIdPresent = Boolean(data?.chatwoot_user_id);

      if (isMountedRef.current) {
        setHasToken(tokenPresent || userIdPresent);
        setLoading(false);
      }
    } catch (err) {
      console.warn("useChatwootToken: erro inesperado", err);
      if (isMountedRef.current) {
        setHasToken(false);
        setLoading(false);
      }
    }
  }, []);

  const markTokenInvalid = useCallback(() => {
    if (!isMountedRef.current) return;
    setHasToken(false);
    setLoading(false);
  }, []);

  useEffect(() => {
    isMountedRef.current = true;
    refresh();

    return () => {
      isMountedRef.current = false;
    };
  }, [refresh]);

  return { hasToken, loading, refresh, markTokenInvalid };
}
